import { Phone, MessageCircle, Clock, MapPin, Link2 } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";
import { PHONE_DISPLAY, PHONE_TEL, openWa } from "@/lib/wa";

export default function Contact() {
  const { t, pick } = useLang();

  return (
    <main>
      <SEO title="اتصل بنا | ميرو للإطارات وخدمات السيارات — 0507359999" description="تواصل مع ميرو للإطارات وخدمات السيارات عبر واتساب أو الهاتف 0507359999 للاستفسار عن خدمات الإطارات المتنقلة في الرياض." path="/contact" />
      <PageHero eyebrow="CONTACT" title={t("contact.title")} sub={t("contact.sub")} />

      <section className="pb-24">
        <div className="mx-auto grid max-w-5xl gap-6 px-5 md:grid-cols-2 lg:px-8">
          <Reveal>
            <a href={PHONE_TEL} className="card-glass group flex h-full flex-col gap-4 p-8 transition-all hover:border-gold/40" data-testid="contact-phone-card">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gold text-ink"><Phone size={24} /></span>
              <h2 className="text-lg font-bold text-white">{t("contact.phone")}</h2>
              <p dir="ltr" className="font-display text-3xl font-extrabold text-gold">{PHONE_DISPLAY}</p>
              <span className="text-sm text-mist">{pick("اضغط للاتصال المباشر", "Tap to call directly")}</span>
            </a>
          </Reveal>
          <Reveal delay={1}>
            <button onClick={() => openWa()} className="card-glass group flex h-full w-full flex-col gap-4 p-8 text-start transition-all hover:border-gold/40" data-testid="contact-wa-card">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#1FAF5A] text-white"><MessageCircle size={24} /></span>
              <h2 className="text-lg font-bold text-white">{t("common.whatsapp")}</h2>
              <p dir="ltr" className="font-display text-xl font-bold text-gold">wa.me/966507359999</p>
              <span className="text-sm text-mist">{pick("محادثة مباشرة دون تسجيل", "Direct chat, no sign-up")}</span>
            </button>
          </Reveal>
          <Reveal>
            <div className="card-glass flex h-full flex-col gap-4 p-8">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/15 text-gold"><Clock size={20} /></span>
              <h2 className="text-base font-bold text-white">{t("contact.hours")}</h2>
              <p className="text-sm leading-8 text-mist">{t("contact.hoursVal")}</p>
            </div>
          </Reveal>
          <Reveal delay={1}>
            <div className="card-glass flex h-full flex-col gap-4 p-8">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/15 text-gold"><MapPin size={20} /></span>
              <h2 className="text-base font-bold text-white">{t("contact.area")}</h2>
              <p className="text-sm leading-8 text-mist">{t("contact.areaVal")}</p>
              <Link to="/riyadh" className="mt-auto inline-flex items-center gap-2 text-sm font-bold text-gold" data-testid="contact-coverage-link">
                <Link2 size={14} /> {t("footer.coverage")}
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
